module.exports = __webpack_public_path__ + "static/work01btn-e19b340baa776bc7fd4a2644f895b007.png";